export default {
  data() {
    return {
      ranks: [
        { rank_id: 1, value: this.$t('ranks.third') },
        { rank_id: 2, value: this.$t('ranks.second') },
        { rank_id: 3, value: this.$t('ranks.first') },
        { rank_id: 4, value: this.$t('ranks.candidate_master_sport') },
        { rank_id: 5, value: this.$t('ranks.master_sport') },
        { rank_id: 6, value: this.$t('ranks.master_sport_international') },
        { rank_id: 7, value: this.$t('ranks.grand_master_sports') }
      ]
    }
  }
}
